import React, { useState } from "react";
import { ItemRow, QuantityInput, Table } from "./styles";
import { Button } from "@material-ui/core";
import usePersonData from "../../hooks/usePersonData";
import { toast } from "react-toastify";

const MaterialsTable = ({ items, person, associatedItems, onClose, refetchItems, getUpdatedItems }) => {
    const [selectedItems, setSelectedItems] = useState([]);

    const { associateWithMultipleMaterials } = usePersonData();

    const handleSave = async () => {
        console.log(selectedItems);
        try {
            await refetchItems();
            const freshItems = getUpdatedItems();

            const conflicts = selectedItems.filter((item) =>
                freshItems.some((freshItem) => freshItem.id === item.id && freshItem.person_id)
            );

            if (conflicts.length > 0) {
                toast.error("Alguns itens foram associados por outro usuário. Atualize a lista.");
                return;
            }

            const toAssociate = selectedItems.map((item) => {
                return { material_id: item.id, qtd: item.quantity, person_id: person.id, obs: item.obs };
            });

            const result = await associateWithMultipleMaterials(toAssociate);

            if (result.success) {
                toast.success("Itens atualizados com sucesso!");
                onClose();
            } else if (result?.data?.message && result?.data?.message.includes("does not have enough quantity")) {
                toast.warn("Quantidade insuficiente");
            } else {
                toast.error("Ocorreu um erro ao associar os itens.");
            }
        } catch (err) {
            console.error(err);
            toast.error("Erro inesperado.");
        } finally {
            setSelectedItems(associatedItems.map((item) => ({ id: item.id, quantity: item.quantity || 1 })));
            await refetchItems();
        }
    };

    const handleSelect = (e, item) => {
        const { checked } = e.target;

        if (checked) {
            setSelectedItems((prev) => [...prev, { id: item.id, quantity: 1, obs: "TAKE" }]);
        } else {
            setSelectedItems((prev) => prev.filter((i) => i.id !== item.id));
        }
    };

    const handleQuantityChange = (itemId, newQuantity) => {
        if (newQuantity === 0) {
            setSelectedItems((prev) => prev.filter((i) => i.id !== itemId));
        } else {
            setSelectedItems((prev) =>
                prev.map((i) => (i.id === itemId ? { ...i, quantity: newQuantity, obs: "TAKE" } : i))
            );
        }
    };

    const handleQuantityChangeToRemove = (itemId, newQuantity) => {
        console.log({ itemId, newQuantity });
        if (newQuantity === 0) {
            setSelectedItems((prev) => prev.filter((i) => i.id !== itemId));
        } else {
            if (selectedItems.some((i) => i.id === itemId)) {
                setSelectedItems((prev) =>
                    prev.map((i) => (i.id === itemId ? { ...i, quantity: newQuantity, obs: "LEAVE" } : i))
                );
            } else {
                setSelectedItems([...selectedItems, { id: itemId, quantity: newQuantity, obs: "LEAVE" }]);
            }
        }
    };

    return (
        <div>
            {associatedItems && associatedItems.length ? (
                <div>
                    <h2>Itens Associados</h2>
                    <Table>
                        <thead>
                            <tr>
                                <th>Nome do Item</th>
                                <th>Quantidade Associada</th>
                                <th>Desassociar (Devolver)</th>
                            </tr>
                        </thead>
                        <tbody>
                            {associatedItems.map((item) => (
                                <ItemRow key={item.id} associated={true}>
                                    <td>{item?.materialName}</td>
                                    <td>{item?.total}</td>
                                    <td>
                                        <QuantityInput
                                            type="number"
                                            min="0"
                                            max={item.total}
                                            value={
                                                selectedItems.find(
                                                    (i) => i.id === item.material_id && i.obs === "LEAVE"
                                                )?.quantity || 0
                                            }
                                            onChange={(e) =>
                                                handleQuantityChangeToRemove(
                                                    item.material_id,
                                                    parseInt(e.target.value, 10)
                                                )
                                            }
                                            onWheel={(e) => e.target.blur()}
                                        />
                                    </td>
                                </ItemRow>
                            ))}
                        </tbody>
                    </Table>
                </div>
            ) : null}
            <div>
                <h2>Itens Disponíveis</h2>
                <Table>
                    <thead>
                        <tr>
                            <th>Selecionar</th>
                            <th>Nome do Item</th>
                            <th>Status</th>
                            <th>Disponíveis</th>
                            <th>Adicionar (Pegar)</th>
                        </tr>
                    </thead>
                    <tbody>
                        {items
                            // .filter((item) => !associatedItems.some((a) => a.material_id === item.id))
                            .map((item) => {
                                const isSelected = selectedItems.some((i) => i.id === item.id && i.obs === "TAKE");
                                const isAssociated = associatedItems.some((a) => a.material_id === item.id);
                                return (
                                    <ItemRow key={item.id} associated={isAssociated}>
                                        <td>
                                            <input
                                                type="checkbox"
                                                checked={isSelected}
                                                onChange={(e) => handleSelect(e, item)}
                                                disabled={item.qtd <= 0}
                                            />
                                        </td>
                                        <td>{item.name}</td>
                                        <td>{item.qtd > 0 ? "Disponível" : "Indisponível"}</td>
                                        <td>{item.qtd ? item.qtd : item.person_id ? 0 : 1}</td>
                                        <td>
                                            {isSelected ? (
                                                <QuantityInput
                                                    type="number"
                                                    min="1"
                                                    max={item.qtd}
                                                    value={
                                                        selectedItems.find((i) => i.id === item.id && i.obs === "TAKE")
                                                            ?.quantity || 1
                                                    }
                                                    onChange={(e) =>
                                                        handleQuantityChange(item.id, parseInt(e.target.value, 10))
                                                    }
                                                    onWheel={(e) => e.target.blur()}
                                                />
                                            ) : (
                                                "-"
                                            )}
                                        </td>
                                    </ItemRow>
                                );
                            })}
                    </tbody>
                </Table>
            </div>

            <div style={{ float: "inline-end", padding: "10px" }}>
                <Button style={{ marginRight: "5px" }} variant="contained" onClick={onClose} color="secondary">
                    Cancelar
                </Button>
                <Button variant="contained" onClick={handleSave} color="primary">
                    Salvar
                </Button>
            </div>
        </div>
    );
};

export default MaterialsTable;
